import {ReferenceDao} from '../../dao';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';

const FUNCTION_CODE = 'DOWNLOAD_REFERENCE_BY_ID';

export async function downloadReferenceById(userData: Record<string, string>, id: number) {
    try {
        return await ReferenceDao.downloadReferenceById(userData.userToken, id);
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
